// extracted by mini-css-extract-plugin
module.exports = {"skipToContentLink":"SkipToMainContent_skipToContentLink__K4Sjh","focus-visible":"SkipToMainContent_focus-visible__dX_SH"};